import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  private refreshCompaniesSubject = new Subject<void>();
  refreshCompanies$ = this.refreshCompaniesSubject.asObservable();
    
  triggerRefreshCompanies() {
    this.refreshCompaniesSubject.next();
  }
}